import { useEffect, useState } from 'react';
import { Alert, Button, Modal, ModalDialog, Stack, Textarea, Typography } from '@mui/joy';

export default function AdditionalStopDialog({ open, busy, error, target, onCancel, onConfirm }) {
  const [reason, setReason] = useState('');
  useEffect(() => {
    if (open) setReason('');
  }, [open]);
  return (
    <Modal
      open={Boolean(open)}
      onClose={() => {
        if (!busy) onCancel?.();
      }}
      sx={{ zIndex: 10110 }}
    >
      <ModalDialog sx={{ width: 'min(460px, calc(100vw - 24px))' }}>
        <Stack spacing={1.5}>
          <Typography level="title-lg">
            {target ? 'Снять дозамер и сменить стадию?' : 'Снять дозамер?'}
          </Typography>
          <Alert color="warning">
            {target
              ? 'Сейчас идёт дозамер. После подтверждения он будет снят и система проверит переход на выбранную стадию.'
              : 'Дозамер будет снят. При наличии финансовой истории текущие назначения и расчёты сохранятся; в остальных случаях восстановится состояние до назначения дозамера. История и файлы останутся.'}
          </Alert>
          {!target && (
            <Typography level="body-sm">
              Чтобы сразу убрать старое событие из работы, выберите «Завершить вручную» в окне смены стадии.
            </Typography>
          )}
          <Textarea
            minRows={2}
            value={reason}
            disabled={busy}
            aria-label="Причина снятия дозамера"
            placeholder="Почему дозамер больше не требуется"
            onChange={(e) => setReason(e.target.value)}
          />
          {error && <Alert color="danger">{error}</Alert>}
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button variant="outlined" color="neutral" disabled={busy} onClick={onCancel}>
              Отмена
            </Button>
            <Button
              color="danger"
              loading={busy}
              disabled={reason.trim().length < 5 || reason.length > 4000}
              onClick={() => onConfirm(reason.trim())}
            >
              Да, снять дозамер
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
